/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSnapshotListRequest {
    getFixupPrototypeFunction() { return TagPostureSnapshotListRequest.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSnapshotListRequest>): TagPostureSnapshotListRequest {
        let obj = Object.assign(new TagPostureSnapshotListRequest(), model);
        TagPostureSnapshotListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSnapshotListRequest>): TagPostureSnapshotListRequest {
        if (!model) return null;
        return TagPostureSnapshotListRequest.newInstance(<TagPostureSnapshotListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSnapshotListRequest) {
        if (!obj) return;

        models.TagPostureSnapshotListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSnapshotListRequest): boolean {
        Object.setPrototypeOf(obj, TagPostureSnapshotListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.TagPostureSnapshotFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.TagPostureSnapshotSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.TagPostureSnapshotSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.TagPostureSnapshotFilters;

}
